import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-tenants",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_6 = { class: "col margin-left-3" }
const _hoisted_7 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  id: "action-loading",
  class: "spinner-border spinner-border-sm"
}
const _hoisted_11 = { class: "pagination-wrapper mt-1" }
const _hoisted_12 = { class: "loader-div-40" }
const _hoisted_13 = ["src"]

import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElSwitch,
  ElTable,
  ElTableColumn,
} from "element-plus";
import { computed, onMounted, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  deleteTenant,
  getTenantList,
  inlineEditTenant,
} from "@/tenant/services/tenant.service";
import { showAlert, showConfirm } from "@/core/popup";
import { router } from "@/core/router";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tenants',
  setup(__props) {

const { t } = i18n.global;

const tenantList = ref([]);
const loadingTenants = ref(false);

const headerStyle = ref({
  color: "black",
  borderBottomColor: "#808080FF",
});

const rowStyle = ref({
  cursor: "pointer",
});

const search = ref("");

const perPageTenants = ref(10);

const currentPageTenants = ref(1);

const editMode = ref(false);
const animate = ref(false);

const hoverId = ref("");

const newObject = ref({
  name: undefined,
  id: undefined,
  active: undefined,
});

const numberOfTenants = computed(() =>
  tenantList.value ? tenantList.value.length : 0
);

const numberOfPagesTenants = computed(() => {
  if (numberOfTenants.value) {
    return Math.ceil(numberOfTenants.value / perPageTenants.value);
  }
  return 0;
});

function cellMouseEnter(row) {
  hoverId.value = row.id;
}

function cellMouseLeave() {
  hoverId.value = "";
}

const tenantsTableData = computed(() => {
  if (tenantList.value) {
    if (numberOfPagesTenants.value === 1) {
      return tenantList.value;
    }
    const start = (currentPageTenants.value - 1) * perPageTenants.value;
    const end = currentPageTenants.value * perPageTenants.value;
    return tenantList.value.slice(start, end);
  }
  return [];
});

function goToEditPage(row) {
  if (hasPermission("TENANTS.LIST.EDIT") && newObject.value.id !== row.id) {
    router.push(`/tenants/edit/${row.id}`);
  } else if (newObject.value.id === row.id) {
    animate.value = true;
    setTimeout(() => {
      animate.value = false;
    }, 2200);
  }
}

function sizeChanged(val) {
  perPageTenants.value = val;
}

function openEditMode(row) {
  animate.value = false;
  if (
    newObject.value.id !== row.id &&
    hasPermission("TENANTS.LIST.INLINE.EDIT")
  ) {
    newObject.value = cloneDeep(row);
    editMode.value = true;
  }
}

function closeEditMode() {
  editMode.value = false;
  newObject.value = {
    name: undefined,
    id: undefined,
    active: undefined,
  };
}

async function changeActiveStatus(tenant) {
  if (hasPermission("TENANTS.LIST.INLINE.EDIT")) {
    const result = await inLineEditTenant(tenant);
    if (result) {
      if (tenant.active) {
        showAlert(TYPE.SUCCESS, t("Tenant.TenantActivated"));
      } else {
        showAlert(TYPE.WARNING, t("Tenant.TenantDeActivated"));
      }
    }
  }
}

async function editSelectedTenant() {
  if (
    editMode.value &&
    newObject.value.name &&
    hasPermission("TENANTS.LIST.INLINE.EDIT")
  ) {
    const result = await inLineEditTenant(newObject.value);
    if (result) {
      editMode.value = false;
      newObject.value = {
        name: undefined,
        id: undefined,
        active: undefined,
      };
      tenantList.value = await getTenantList();
      showAlert(TYPE.SUCCESS, t("Tenant.TenantSaved"));
    }
  } else if (hasPermission("TENANTS.LIST.INLINE.EDIT")) {
    showAlert(TYPE.WARNING, t("Common.WarningName"));
  }
}

async function inLineEditTenant(tenant) {
  let result = false;
  await inlineEditTenant(tenant).then(async (response) => {
    if (response) {
      result = true;
    }
  });
  return result;
}

async function getTenants() {
  loadingTenants.value = true;
  await getTenantList().then((list) => {
    if (list) {
      tenantList.value = list;
    }
  });
  loadingTenants.value = false;
}

async function deleteSelectedTenant(tenant) {
  if (hasPermission("TENANTS.LIST.REMOVE")) {
    const isConfirmed = await showConfirm(
      "warning",
      t("Tenant.DeleteTenant"),
      t("Tenant.DeleteQuestion")
    );
    if (isConfirmed) {
      tenant.loading = true;
      const result = await deleteTenant(tenant.id);
      tenant.loading = false;
      if (result) {
        await getTenants();
      } else {
        showAlert(TYPE.ERROR, t("Tenant.DeleteFailed"));
      }
    }
  }
}

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

onMounted(() => {
  getTenants();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), {
      class: "card",
      "body-style": { height: '100%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTable), {
          data: 
          search.value
            ? tenantList.value.filter((data) =>
                data.name.toLowerCase().includes(search.value.toLowerCase())
              )
            : tenantsTableData.value
        ,
          "empty-text": loadingTenants.value ? ' ' : _unref(t)('Common.NoData'),
          onRowClick: goToEditPage,
          onCellMouseEnter: cellMouseEnter,
          onCellMouseLeave: cellMouseLeave,
          "row-style": _unref(hasPermission)('TENANTS.LIST.EDIT') ? rowStyle.value : undefined,
          height: "98%",
          "header-cell-style": headerStyle.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Name'),
              prop: "name",
              sortable: "",
              width: "300px"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      placeholder: _unref(t)('Common.Name'),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      modelValue: newObject.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newObject.value.name) = $event))
                    }, null, 8, ["placeholder", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("strong", null, _toDisplayString(scope.row.name), 1),
                      (
                  _unref(hasPermission)('TENANTS.LIST.INLINE.EDIT') &&
                  hoverId.value === scope.row.id
                )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "pencil-span",
                            onClick: _withModifiers(($event: any) => (openEditMode(scope.row)), ["stop"])
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                          ], 8, _hoisted_3))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Connectors'),
              prop: "connectors",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.connectors, (connector) => {
                  return (_openBlock(), _createElementBlock("img", {
                    class: "logo margin-right-10",
                    key: connector.id,
                    src: `${_unref(ASSETS_BASE_URL)}/${
                connector.connectorSpecId
              }${_unref(getResolution)(false)}.png`,
                    alt: connector.name
                  }, null, 8, _hoisted_4))
                }), 128))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.CreationTime'),
              prop: "createdAt",
              sortable: "",
              width: "130px"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(convertDate(scope.row.createdAt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Active'),
              prop: "active",
              width: "130px"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 0,
                      "active-color": "#5022a6",
                      modelValue: newObject.value.active,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newObject.value.active) = $event)),
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 1,
                      "active-color": "#5022a6",
                      modelValue: scope.row.active,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.active) = $event),
                      onClick: _withModifiers(($event: any) => (changeActiveStatus(scope.row)), ["stop"]),
                      disabled: !_unref(hasPermission)('TENANTS.LIST.INLINE.EDIT')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick", "disabled"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              prop: "actions",
              width: "300px"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(ElInput), {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                    size: "mini",
                    style: {"max-width":"170px"},
                    placeholder: _unref(t)('Common.TypeToSearch')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ElButton), {
                      class: "no-border btn-oneTeg2",
                      size: "mini",
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(router).push('/tenants/create')), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      loading: loadingTenants.value,
                      onClick: _withModifiers(getTenants, ["stop"]),
                      class: "no-border btn-oneTeg margin-left-3",
                      size: "mini",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_7, [
                  (
                  editMode.value &&
                  scope.row.id === newObject.value.id &&
                  _unref(hasPermission)('TENANTS.LIST.INLINE.EDIT')
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ animateBtn: animate.value })
                        }, [
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg",
                            style: {"max-width":"42.5px"},
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(editSelectedTenant, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "check" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg margin-left-3",
                            "native-type": "submit",
                            size: "mini",
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (closeEditMode()), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "times" })
                            ]),
                            _: 1
                          })
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(ElDropdown), null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                (_unref(hasPermission)('TENANTS.LIST.VIEW_DETAIL'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (
                          _unref(router).push('/tenants/details/' + scope.row.id)
                        ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Details")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (_unref(hasPermission)('TENANTS.LIST.EDIT'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (
                          _unref(router).push('/tenants/edit/' + scope.row.id)
                        ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (_unref(hasPermission)('TENANTS.LIST.REMOVE'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 2,
                                      onClick: _withModifiers(($event: any) => (deleteSelectedTenant(scope.row)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              class: "no-border btn-oneTeg show-on-row-hover",
                              size: "mini",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "cog" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_10, null, 512), [
                  [_vShow, scope.row.loading]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text", "row-style", "header-cell-style"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(OneTegPagination, {
            "page-sizes": [10, 25, 50, 100],
            "page-size": perPageTenants.value,
            "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((perPageTenants).value = $event)),
            total: numberOfTenants.value,
            "current-page": currentPageTenants.value,
            "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((currentPageTenants).value = $event)),
            background: true,
            small: true,
            onSizeChange: sizeChanged,
            layout: 'total, sizes, prev, pager, next'
          }, null, 8, ["page-size", "total", "current-page"])
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_13)
    ], 512), [
      [_vShow, loadingTenants.value]
    ])
  ]))
}
}

})